var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.1 436.1",
    width: 200,
    height: 200,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#49c1bf}.st1{fill:#077a8f}.st2{fill:#298e97}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.693 -109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    className: "st0",
    d: "M117.4 289.2l-62.8 28L-112 402l166.6 80.1V349.7l62.8-28.3V517l-62.8 28-245.3-117.4v-62.4l169.8-83.3-169.8-81.6V137l63.8-28 244.3 117.6v62.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.693 -109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    className: "st1",
    d: "M-190.7 137L54.6 254.6l62.8-28L-126.9 109l-63.8 28z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.695 -100.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    className: "st2",
    d: "M36.6 245.7l62.8-28v62.6l-62.8 28v-62.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.693 -106.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    className: "st0",
    d: "M-190.7 135v63.3l169.8 81.6-169.8 83.3v62.4L54.6 543v-62.8L-112 400l166.6-84.8v-62.6L-190.7 135z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.695 -93.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    className: "st2",
    d: "M36.6 529l62.8-28V305.4l-62.8 28.3V529z"
  }))));
};
export default SvgLogoNoText;